export type CellOrigins = {
  platform_api: string;
  connect_api: string;
  core_api: string;
  agentos: string;
  voice: string;
};

export type DirectoryCell = {
  object: string;
  operator_id: string;
  code: string;
  name: string;
  headquarters_country: string;
  workos_organization_id: string;
  status: string;
  origins: CellOrigins;
  hub_origin: string;
  portal_origin: string;
};

let bound: DirectoryCell | null = null;
const listeners = new Set<() => void>();

export function bindCell(cell: DirectoryCell | null): void {
  bound = cell;
  for (const listener of listeners) listener();
}

export function getBoundCell(): DirectoryCell | null {
  return bound;
}

export function subscribeBoundCell(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function requireBoundCell(): DirectoryCell {
  if (!bound) throw new Error('No cell bound');
  return bound;
}
